const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "210.958 89.105 54.6 55.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.041621, -55.295268)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 175.9,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.5,
    y: 175.9,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 175.9,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 184.2,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.5,
    y: 184.2,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 184.2,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 167.6,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.5,
    y: 167.6,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 167.6,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.6,
    y: 152.1,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.6,
    y: 152.1,
    width: 6.1,
    height: 6.1,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8,197.2v-51.4c0-0.8-0.6-1.4-1.4-1.4H252c-0.8,0-1.4,0.6-1.4,1.4v14.9h-16.4c-0.8,0-1.4,0.6-1.4,1.4v35.2h-5.8v2.8 h7.2H252h15.7h6.7h7.2v-2.8H275.8z M246.1,192.5v4.7h-10.6v-33.7h30.7v33.7h-11.4v-4.7H246.1z M273,147.2v50h-3.9V162 c0-0.8-0.6-1.4-1.4-1.4h-14.3v-13.5H273z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.8fe556f23457c9e33a72eeb2a7ce636a.svg";
export { ForwardRef as ReactComponent };